// Copyright (c) 2020 Deere & Company

import './app-logo.scss';
import React from 'react';

const AppLogo = () => <span className="app-logo" />;

export default AppLogo;
